<span class="message">
  @if (data.type === 'error') {
    <mat-icon color="warn">error</mat-icon>
  }
  @if (data.type === 'warn') {
    <mat-icon>error</mat-icon>
  }
  @if (data.type === 'info') {
    <mat-icon>check_circle</mat-icon>
  }
  <span class="ms-1">{{data.message}}</span>
  @if (!data.showDetails) {
    <button class="ms-1" (click)="dismiss()" color="accent" mat-button>
      {{data.action}}
    </button>
  }

  @if (data.showDetails) {
    <button class="ms-1" (click)="showDetails()" color="accent" mat-button>
      details
    </button>
  }
</span>